import React, { memo, PureComponent } from "react";

import { withGPT } from "src/gpt";
import { setDangerousHtml, genUID } from "src/utils";

import styles from "./style.css";

// TODO: Refactor AdUnit to use the new React hooks

class AdUnitBody extends PureComponent {
  constructor(props) {
    super(props);

    const { uniqueSlotId = true, dfpAdUnitId, code, bingDivId } = props;
    const _dfpAdUnitId = dfpAdUnitId || code;

    this.state = {
      dfpAdUnitId: _dfpAdUnitId,
      elemId: uniqueSlotId ? _dfpAdUnitId + "_" + genUID() : _dfpAdUnitId,
      dfpPlaceHolder: "dfp-placeholder-" + genUID(),
      bingNativePlaceHolder: "bing-placeholder-" + genUID(),
      bingNativeDivId: bingDivId ? bingDivId : "bingNativeTop",
      provider: this.getProvider(props),
      size: this.getSize(props)
    };
  }

  getSize = props => {
    const { size, dimensions } = props;

    if (size) {
      return size
        .split(",")
        .map(dim => (dim.indexOf("fluid") > -1 ? "fluid" : [parseInt(dim.trim().split("x")[0]), parseInt(dim.trim().split("x")[1])]));
    } else if (Array.isArray(dimensions)) {
      return dimensions;
    }
    return [[300, 250], [320, 50], [216, 54], "fluid"];
  };

  getProvider = props => {
    const { bingSplit, bingDivId = "bingNativeTop", backgroundScript } = props;

    if (backgroundScript && document && (document.visibilityState || document.webkitVisibilityState) != "visible") {
      return "background";
    } else if (bingSplit > 0 && document.getElementById(bingDivId)) {
      return "bing-preloaded";
    } else {
      const random = Math.random() * 100;
      if (random <= bingSplit) {
        return "bing";
      } else {
        return "dfp";
      }
    }
  };

  setupBing = provider => {
    const { elemId, dfpPlaceHolder, bingNativeDivId, bingNativePlaceHolder } = this.state;
    const { bingTimeout } = this.props;

    if (provider == "bing-preloaded" && document.getElementById(bingNativeDivId)) {
      document.getElementById(bingNativePlaceHolder).appendChild(document.getElementById(bingNativeDivId));
    }
    if (window.afAdRequest) {
      window.afAdRequest("adrequest", window.location.hostname + "-" + bingNativeDivId, "bingNative");
    }

    const bingNativeTimeOut = () => {
      setTimeout(() => {
        if (document.getElementById(bingNativeDivId)) {
          let htmlstring = document.getElementById(bingNativeDivId).innerHTML;
          htmlstring = htmlstring.trim ? htmlstring.trim() : htmlstring.replace(/^\s+/, "");

          if (htmlstring == "" || htmlstring == '<div id="' + bingNativeDivId + '"></div>') {
            document.getElementById(bingNativeDivId).outerHTML = "";
            const html = '<div id="' + elemId + '" class="dfpTag"></div>';
            document.getElementById(dfpPlaceHolder).innerHTML = html;
            this.setupGPT();

            if (window.afAdRequest) {
              window.afAdRequest("unfilled", window.location.hostname + "-" + bingNativeDivId, "bingNative");
            }
          } else {
            if (window.afAdRequest) {
              window.afAdRequest("impression", window.location.hostname + "-" + bingNativeDivId, "bingNative");
            }
          }
        }
      }, bingTimeout);
    };

    if (bingNativeDivId.toLowerCase().indexOf("bottom") < 0) {
      bingNativeTimeOut();
    }
  };

  setupGPT = () => {
    const { elemId, size, dfpAdUnitId } = this.state;
    const { setIndexExchangeTargeting, gptCtx, useDfpSafeFrame, clientid, variant, brand, repclientid, multiClientDomain } = this.props;

    if (dfpAdUnitId) {
      // If setup once, don't redefine slot
      if (!gptCtx.definedSlots.has(elemId)) {
        window.googletag.cmd.push(() => {
          var slot = window.googletag
            .defineSlot(dfpAdUnitId, size, elemId)
            .setTargeting("client", [repclientid || clientid])
            .setTargeting("segment", [multiClientDomain ? "CL" + (repclientid || clientid) + "-" + (brand || "af-home") : brand])
            .setTargeting("variant", [variant])
            .setTargeting("browserTabStatus", document && document.visibilityState != "visible" ? "background" : "foreground");
          if (setIndexExchangeTargeting) slot = slot.setTargeting("ix-adslot", dfpAdUnitId);
          if (useDfpSafeFrame == true) slot = slot.setForceSafeFrame(true);
          window[elemId] = slot.addService(window.googletag.pubads());
          // Update the context with the defined slot
          gptCtx.definedSlots.add(elemId);
        });
      }

      // But still refresh ad
      window.googletag.pubads();

      // If document not hidden (not bg tab) display ad and refresh slot, otherwise render BackgroundScript
      window.googletag.cmd.push(() => {
        window.googletag.display(elemId);
        window.googletag.pubads().refresh([window[elemId]]);
      });
    }
  };

  componentDidMount() {
    const { provider } = this.state;

    switch (provider) {
      case "background":
        break;
      case "bing":
        this.setupBing(provider);
        break;
      case "bing-preloaded":
        this.setupBing(provider);
        break;
      default:
        this.setupGPT();
    }
  }

  render() {
    const { elemId, dfpPlaceHolder, bingNativePlaceHolder, bingNativeDivId, provider } = this.state;

    const { bingJsTag, backgroundScript, stickyAd } = this.props;

    switch (provider) {
      case "bing-preloaded":
        return (
          <div class={[styles.container, stickyAd ? styles.stickyAd : ''].join(' ')}>
            <div id={dfpPlaceHolder} class={styles.dfp} />
            <div id={bingNativePlaceHolder} class={styles.container} />
          </div>
        );
      case "bing":
        return (
          <div class={[styles.container, stickyAd ? styles.stickyAd : ''].join(' ')}>
            <div id={dfpPlaceHolder} class={styles.dfp} />
            <div id={bingNativeDivId} class={styles.bingNative} />
            <div ref={setDangerousHtml(bingJsTag)} />
          </div>
        );
      default:
        return (
          <React.Fragment>
            {// If document  hidden (bg tab) render BackgroundScript
            document.hidden && <BackgroundScript backgroundScript={backgroundScript} />}
            <div id={elemId} class={[styles.paddedContainer, stickyAd ? styles.stickyAd : ''].join(' ')} />
          </React.Fragment>
        );
    }
  }
}

const BackgroundScript = memo(props => {
  const { backgroundScript } = props;
  return backgroundScript ? <div ref={setDangerousHtml(backgroundScript)} /> : null;
});

export default withGPT(AdUnitBody);
